import React, { Component } from 'react';
import { Input, Table, Icon, Menu, message } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Search } = Input;
const PAGE_SIZE = 10;
// const CATEGORY = {
//   '1': 'IP Camera',
//   '2': 'Communication & Storage',
//   '3': 'AlarmHub & Sensor'
// };

// 表格类型
// const columns = [
//   {
//     width: '15%',
//     title: <FormattedMessage id="category" />,
//     dataIndex: 'category',
//     key: 'category',
//     render: (text, record) => this.state.CATEGORY[text]
//   },
//   {
//     width: '15%',
//     title: <FormattedMessage id="model" />,
//     dataIndex: 'model',
//     key: 'model',
//   },
//   {
//     width: '35%',
//     title: <FormattedMessage id="remark" />,
//     dataIndex: 'remark',
//     key: 'remark',
//   },
//   {
//     width: '100px',
//     title: <FormattedMessage id="license" />,
//     dataIndex: 'licenseUrl',
//     key: 'licenseUrl',
//     render: (text, record) => (
//       <a target="_blank" href={text}>
//         <Icon type="file-text" />
//       </a>
//     ),
//   },
//   {
//     width: '100px',
//     title: <FormattedMessage id="source" />,
//     dataIndex: 'sourceUrl',
//     key: 'sourceUrl',
//     render: (text, record) => (
//       <span>
//         <a target="_blank" href={text}>
//           <Icon type="folder" />
//         </a>
//       </span>
//     ),
//   },
//   // {
//   //   width: '100px',
//   //   title: <FormattedMessage id="inquiry" />,
//   //   key: 'inquiry',
//   //   render: (text, record) => (
//   //     <span>
//   //       <a target="_blank" href={`/inquiry?key=${record.key}`}>
//   //         <Icon type="mail" />
//   //       </a>
//   //     </span>
//   //   ),
//   // },
// ];

class MySearch extends Component {
  constructor() {
    super();
    this.state = {
      isStartSearch: false,
      currentNav: '',
      data: [],
      loading: false,
      pagination: {},
      category: '',
      search: '',
      CATEGORY: {},
      categoryList: [],
      columns: [
        {
          width: '15%',
          title: <FormattedMessage id="category" />,
          dataIndex: 'category',
          key: 'category',
          render: (text, record) => this.state.CATEGORY[text]
        },
        {
          width: '15%',
          title: <FormattedMessage id="model" />,
          dataIndex: 'model',
          key: 'model',
        },
        {
          width: '35%',
          title: <FormattedMessage id="remark" />,
          dataIndex: 'remark',
          key: 'remark',
        },
        {
          width: '100px',
          title: <FormattedMessage id="license" />,
          dataIndex: 'licenseUrl',
          key: 'licenseUrl',
          render: (text, record) => (
            <a target="_blank" href={text}>
              <Icon type="file-text" />
            </a>
          ),
        },
        {
          width: '100px',
          title: <FormattedMessage id="source" />,
          dataIndex: 'sourceUrl',
          key: 'sourceUrl',
          render: (text, record) => (
            <span>
              <a target="_blank" href={text}>
                <Icon type="folder" />
              </a>
            </span>
          ),
        },
        // {
        //   width: '100px',
        //   title: <FormattedMessage id="inquiry" />,
        //   key: 'inquiry',
        //   render: (text, record) => (
        //     <span>
        //       <a target="_blank" href={`/inquiry?key=${record.key}`}>
        //         <Icon type="mail" />
        //       </a>
        //     </span>
        //   ),
        // },
      ]
    };
    this.fetchData = this.fetchData.bind(this);
    this.fetchCategory = this.fetchCategory.bind(this);
    this.navClick = this.navClick.bind(this);
    this.searchClick = this.searchClick.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
  }

  componentDidMount () {
    this.searchInput.focus();
    this.fetchCategory();
  }

  // 导航点击
  navClick (e) {
    const pager = { ...this.state.pagination };
    pager.current = 1;
    this.setState({
      pagination: pager,
      currentNav: e.key,
    });
    this.fetchData({
      category: e.key,
      search: '',
      pageStart: 0,
    });
  }

  searchClick (value) {
    const pager = { ...this.state.pagination };
    pager.current = 1;
    this.setState({
      currentNav: '',
      pagination: pager,
    });
    this.fetchData({
      search: value,
      category: '',
      pageStart: 0,
    });
  }

  handleTableChange (pagination) {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetchData({
      category: this.state.category,
      search: this.state.search,
      pageStart: (pagination.current - 1) * PAGE_SIZE,
    });
  }

  // 类目查询
  fetchCategory () {
    let queryUrl = "/api/category";
    fetch(queryUrl, {
      method: 'GET'
    })
      .then(res => res.json())
      .then((res) => {
        if (res.retcode === 0) {
          let data = res.data.cats;
          let map = {};
          if (data && data.length > 0) {
            data.forEach(item => {
              map[item.key] = item.category;
            })
          }
          this.setState({
            CATEGORY: map,
            categoryList: data,
          });
        } else {
          message.error('get category failed.');
        }
      });
  }

  // 执行查询
  fetchData (param) {
    this.setState({
      category: param.category,
      search: param.search,
      loading: true,
      isStartSearch: true,
    });
    let queryUrl = `/api/software?pageSize=${PAGE_SIZE}&pageStart=${
      param.pageStart
      }&`;
    if (param.category) {
      queryUrl += `category=${param.category}&`;
    }
    if (param.search) {
      queryUrl += `search=${param.search}&`;
    }
    fetch(queryUrl, {
      method: 'GET',
    })
      .then(res => res.json())
      .then((res) => {
        if (res.retcode === 0) {
          const pagination = { ...this.state.pagination };
          pagination.total = res.data.count;
          this.setState({
            loading: false,
            data: res.data.rows,
            pagination,
          });
        } else {
          this.setState({
            loading: false,
          });
          message.error('search failed.');
        }
      });
  }

  render () {
    const renderMenu = (item) => {
      return <Menu.Item key={item.key}>{item.category}</Menu.Item>
    }
    return (
      <div>
        <div>
          <Menu
            onClick={this.navClick}
            selectedKeys={[this.state.currentNav]}
            mode="horizontal"
          >
            {/* <Menu.Item key="1">IP Camera</Menu.Item>
            <Menu.Item key="2">Communication & Storage</Menu.Item>
            <Menu.Item key="3">AlarmHub & Sensor</Menu.Item> */}
            {
              this.state.categoryList.map(item => {
                return renderMenu(item)
              })
            }
          </Menu>
        </div>
        <div
          className={`searchBox ${
            this.state.isStartSearch ? 'searchBox-toTop' : ''
            }`}
        >
          <Search
            // placeholder=""
            onSearch={this.searchClick}
            enterButton
            size="large"
            ref={(node) => {
              this.searchInput = node;
            }}
          />
        </div>
        <div className={`tableBox ${this.state.isStartSearch ? '' : 'hide'}`}>
          <Table
            columns={this.state.columns}
            dataSource={this.state.data}
            pagination={this.state.pagination}
            loading={this.state.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </div>
    );
  }
}

export default MySearch;



// WEBPACK FOOTER //
// ./src/MySearch.js